import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
    border-radius: 50%;
    height: 24px;
    width: 24px;
    border: 2px solid #dedede;
    border-right-color: transparent;
    animation: ${rotate} 1s linear infinite;
`;

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const SpinnerLoader = () => {
    return (
        <Container>
            <Spinner />
        </Container>
    );
};
